module.exports = __webpack_public_path__ + "img/commission.023ab130.svg";